const Resources = {
    breadcrumb: [
        {
            name: "Home",
            href: "/",
            arrow: "<span class='slash'>/</span>",
        },
        {
            name: "Reports",
            href: "/reports",
            arrow: "<span class='slash'>/</span>",
        },
    ],

    headers_main_table: [
        {
          title: 'Description',
          dataKey: 'description'
        },
        {
          title: 'Daily Minutes',
          dataKey: 'daily_minutes'
        },
        {
          title: 'Days/Week',
          dataKey: 'frequency_week'
        },
        {
            title: 'Annual Hours',
            dataKey: 'annual_hours'
        },
        {
            title: 'FTEs',
            dataKey: 'ftes'
        }
    ],

    headers_project_table: [
        {
          title: 'Description',
          dataKey: 'description'
        },
        {
          title: 'Annual Frequency',
          dataKey: 'frequency_week'
        },
        {
            title: 'Annual Hours',
            dataKey: 'annual_hours'
        },
        {
            title: 'FTEs',
            dataKey: 'ftes'
        }
    ],

    headers_variable_items_table: [
        {
            title: 'Description',
            dataKey: 'name'
        },
        {
            title: '#',
            dataKey: 'number'
        },
        {
            title: 'Emp/Procedure',
            dataKey: 'emp_procedure'
        },
        {
            title: 'Minutes',
            dataKey: 'minutes'
        },
        {
            title: 'Daily Minutes',
            dataKey: 'daily_minutes'
        },
        {
            title: 'Days/Week',
            dataKey: 'days'
        },
        {
            title: 'Annual Hours',
            dataKey: 'annual_hours'
        },
        {
            title: 'FTEs',
            dataKey: 'ftes'
        }
    ],


}

export default Resources;